import React, { useState, useEffect } from "react";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { getStorage, ref, deleteObject, listAll, getDownloadURL } from "firebase/storage"; 
import Alerta from '../../../components/Alerta';

const ListaImagenesMisApp = () => {
    const [imagenesMisApp, setImagenesMisApp] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const storage = getStorage();

    useEffect(() => {
        const fetchImages = async () => {
            const listRef = ref(storage, 'fotoslidermisappcalocho/');
            const res = await listAll(listRef);

            const urls = await Promise.all(
                res.items.map(async (itemRef) => {
                    const url = await getDownloadURL(itemRef);
                    return { url, name: itemRef.name };
                })
            );
            setImagenesMisApp(urls);
        };

        fetchImages();
    }, []);

    const handleEliminarImagenesMisApp = async (urlImagen) => {
        try {
            const fileRef = ref(storage, urlImagen);

            await deleteObject(fileRef).then(() => {
                console.log('Imagen eliminada con éxito');
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Imagen eliminada con éxito' });

                setImagenesMisApp((prevImagenes) => prevImagenes.filter(img => img.url !== urlImagen));
            }).catch((error) => {
                console.error('Error al eliminar la imagen:', error);
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al eliminar la imagen' });
            });
        } catch (error) {
            console.log(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Hubo un error al eliminar la imagen' });
        }
    }

    return (
        <ImageList
          sx={{
            width: '100%',
            height: '85%',
            gap: { xs: 2, sm: 4 },
            padding: { xs: 1, sm: 2, md: 3 },
          }}
          cols={{ xs: 1, sm: 2, md: 3, lg: 4 }} 
        >
            <ImageListItem key="Subheader" cols={2}>
                <ListSubheader
                  component="div"
                  sx={{
                    fontSize: { xs: '18px', sm: '22px', md: '25px' },
                    textAlign: 'center',
                    padding: { xs: 1, sm: 2 },
                  }}
                >
                  Lista de imágenes de la sección Mis App
                </ListSubheader>
            </ImageListItem>
            {imagenesMisApp.map((imagenesmisapp) => (
                <ImageListItem key={imagenesmisapp.url}>
                    <img
                        src={imagenesmisapp.url}
                        alt={imagenesmisapp.name}
                        loading="lazy"
                        style={{
                          width: '100%',
                          height: 'auto',
                          objectFit: 'cover',
                          borderRadius: '8px',
                        }}
                    />
                    <ImageListItemBar
                        title={imagenesmisapp.name}
                        sx={{
                          fontSize: { xs: '12px', sm: '14px', md: '16px' },
                          padding: { xs: 1, sm: 2 },
                        }}
                        actionIcon={
                            <IconButton
                              sx={{
                                color: 'rgba(255, 255, 255, 0.54)',
                                fontSize: { xs: '16px', sm: '20px', md: '24px' },
                              }}
                              aria-label={`eliminar ${imagenesmisapp.name}`}
                              onClick={() => handleEliminarImagenesMisApp(imagenesmisapp.url)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        }
                    />
                </ImageListItem>
            ))}
            <Alerta
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </ImageList>
    );
}

export default ListaImagenesMisApp;
